import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import HeroBanner from '~/containers/HeroBanner';
import Container from '~/components/Container';
import IconBackBlack from '~/components/svg/icon-back-black.svg';
import IconBackWhite from '~/components/svg/icon-back-white.svg';
import IconNextBlack from '~/components/svg/icon-next-black.svg';
import IconNextWhite from '~/components/svg/icon-next-white.svg';

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iconNext: <IconNextBlack width="24px" height="24px" />,
      iconBack: <IconBackBlack width="24px" height="24px" />,
    };
  }

  handleClickBack = (value) => {
    const { handleClickOption } = this.props;
    console.log('vo back ne', value);
    if (value > 0) {
      handleClickOption(value - 1);
    }
    this.setState({
      iconNext: <IconNextBlack width="24px" height="24px" />,
      iconBack: <IconBackBlack width="24px" height="24px" />,
    });
  };

  handleClickNext = (value) => {
    const { handleClickOption } = this.props;
    if (value < 2) {
      handleClickOption(value + 1);
    }
    this.setState({
      iconNext: <IconNextBlack width="24px" height="24px" />,
      iconBack: <IconBackBlack width="24px" height="24px" />,
    });
  };
  render() {
    const { t, option } = this.props;
    return (
      <Container>
        <div className="pagination-container">
          {option !== 0 && (
            <div
              className={'pagination-back-container '}
              onClick={() => {
                this.handleClickBack(option);
                window.scrollTo(0, 0);
              }}
              onMouseOver={(e) =>
                this.setState({
                  iconBack: <IconBackWhite width="24px" height="24px" />,
                })
              }
              onMouseOut={(e) =>
                this.setState({
                  iconBack: <IconBackBlack width="24px" height="24px" />,
                })
              }
            >
              <div className="back-content">
                {/* <IconBackBlack style={{ marginRight: '4px' }} /> */}
                <div className="icon-container">{this.state.iconBack}</div>
                {t('back')}
              </div>
            </div>
          )}
          {option !== 2 && (
            <div
              className={'pagination-next-container '}
              onClick={() => {
                this.handleClickNext(option);
                window.scrollTo(0, 0);
              }}
              onMouseOver={(e) =>
                this.setState({
                  iconNext: <IconNextWhite width="24px" height="24px" />,
                })
              }
              onMouseOut={(e) =>
                this.setState({
                  iconNext: <IconNextBlack width="24px" height="24px" />,
                })
              }
            >
              <div className="next-content">
                {t('next')}
                <div className="icon-container">{this.state.iconNext}</div>
                {/* <IconNextWhite style={{ marginLeft: '4px' }} /> */}
              </div>
            </div>
          )}
          <style jsx>
            {`
              .pagination-container {
                display: flex;
                justify-content: center;
                gap: 16px;
                margin-top: 32px;
              }
              .pagination-back-container,
              .pagination-next-container {
                display: flex;
                width: fit-content;
                padding: 12px 16px;
                border: 2px solid #1b2833;
                box-sizing: border-box;
                border-radius: 100px;
                cursor: pointer;
              }
              .active {
                background: #1b2833;
              }
              .back-content,
              .next-content {
                display: flex;
                flex-direction: row;
                gap: 8px;
              }
              .pagination-back-container:hover,
              .pagination-next-container:hover {
                background: #1b2833;
                color: #ffffff;
              }
            `}
          </style>
        </div>
      </Container>
    );
  }
}

export default Pagination;
